import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  contracts: [],
  hasAnyExpiredContract: false,
});

const singleFamilyEnterprise = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === DispatchConstants.SINGLE_FAMILY_SET_CONTRACTS) {
    return Object.assign({}, state, payload);
  }

  return state;
};

export default singleFamilyEnterprise;
